/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiErrorResponseFromJSON, StreemApiErrorResponseToJSON, } from './';
export function StreemApiRecordEventsResponseFailureFromJSON(json) {
    return StreemApiRecordEventsResponseFailureFromJSONTyped(json, false);
}
export function StreemApiRecordEventsResponseFailureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': !exists(json, 'index') ? undefined : json['index'],
        'error': !exists(json, 'error') ? undefined : StreemApiErrorResponseFromJSON(json['error']),
    };
}
export function StreemApiRecordEventsResponseFailureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'error': StreemApiErrorResponseToJSON(value.error),
    };
}
//# sourceMappingURL=StreemApiRecordEventsResponseFailure.js.map